import React from 'react';
import Animated, { useDerivedValue } from 'react-native-reanimated';
import { useSx, SxProp } from 'dripsy';
import { Platform } from 'react-native';

import { AnimatedText } from '../../common/AnimatedText';
import { IS_WEB, formatPlayerTimeFromMs } from '@utils';

interface IPlayerTimeTextProps {
  progress: Animated.SharedValue<number>;
  maximumValue: Animated.SharedValue<number>;
}

const textStyle: SxProp = {
  color: '$background0',
  variant: IS_WEB ? 'text.small' : 'text.xxsmall',
  pb: Platform.select({ ios: '$1' }),
};

export function PlayerTimeText({
  progress,
  maximumValue,
}: IPlayerTimeTextProps) {
  const sx = useSx();

  const text = useDerivedValue(
    () =>
      `${formatPlayerTimeFromMs(
        progress.value,
      )} / ${formatPlayerTimeFromMs(maximumValue.value)}`,
  );

  return <AnimatedText text={text} style={sx(textStyle)} />;
}
